import { PlayerRef } from "@remotion/player";
import React from "react";
import { useMediaQuery } from "react-responsive";
import { MOBILE_VIEW } from "../../../../../../../variables";
import DesktopView from "./desktop-view";
import MobileView from "./mobile-view";

export const ActionRow: React.FC<{
  playerRef: React.RefObject<PlayerRef | null>;
}> = ({ playerRef }) => {
  const isMobile = useMediaQuery({ query: `(max-width: ${MOBILE_VIEW}px)` });

  return isMobile ? (
    <MobileView playerRef={playerRef} />
  ) : (
    <DesktopView playerRef={playerRef} />
  );
};
